import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {GruppeRessurs} from "felles/tjenester/ressurser/GruppeRessurs";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {PlanRessurs} from "../../../../../felles/tjenester/ressurser/PlanRessurs";
import {ModelloppdateringTjeneste} from "../../../../tjenester/ModelloppdateringTjeneste";

const css = require('./redigerPlanDialog.scss');

export function registrerRedigerPlanDialog(angular: IModule) {
    angular
        .service(RedigerPlanDialog.regNavn, RedigerPlanDialog.forInjisering())
        .controller(RedigerPlanDialogKontroller.regNavn, RedigerPlanDialogKontroller.forInjisering());
}

export class RedigerPlanDialog {
    static regNavn = "wm.oppgave.modale.redigerPlanDialog.RedigerPlanDialog";

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            RedigerPlanDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    private dialogKonfigurasjon = {
        template: require('./redigerPlanDialog.html'),
        controller: RedigerPlanDialogKontroller.regNavn,
        controllerAs: 'ktr',
        bindToController: true
    };

    visRedigerPlanDialog(plan: l.PlanModell) {
        this.$mdDialog.show(_.defaults({}, this.dialogKonfigurasjon, {locals: {plan: plan}}));
    }
}

export class RedigerPlanDialogKontroller implements MdDialogController {
    static regNavn = "wm.oppgave.modale.redigerPlanDialog.RedigerPlanDialogKontroller";

    static forInjisering() {
        return [
            PlanRessurs.regNavn,
            GruppeRessurs.regNavn,
            regNavn.md.$mdDialog,
            ModelloppdateringTjeneste.regNavn,
            RedigerPlanDialogKontroller
        ]
    }


    constructor(private planRes: PlanRessurs,
                private gruppeRes: GruppeRessurs,
                private $mdDialog: angular.material.IDialogService,
                private modelloppdatering: ModelloppdateringTjeneste) {
    }

    $onInit(){
        this.initData();
    }

    plan: l.PlanModell; //satt via locals.plan i dialogKonfigurasjon
    planskjemamodell: OppdaterNummmerSpesifikasjon;

    lagrer = false;


    lagre(skjema) {
        console.log(skjema);
        if (!skjema.$valid) return;

        this.planRes.settFoersteNummer(this.plan.id,this.planskjemamodell.foersteMoetenummer, this.planskjemamodell.foersteSaksnummer).$promise
            .then(plan => {
                this.modelloppdatering.broadcastLokalOppdatertPlanId(plan.id);
                this.lukkDialog();
            })
            .finally(() => this.lagrer = false);

    }

    avbryt() {
        this.lukkDialog();
    }

    //hjelpemetoder

    private initData() {
        this.planskjemamodell = new OppdaterNummmerSpesifikasjon(this.plan);
    }

    private lukkDialog() {
        this.$mdDialog.hide();
    }
}

class OppdaterNummmerSpesifikasjon {
    foersteMoetenummer:number;
    foersteSaksnummer:number;

    constructor(plan:l.PlanModell) {
        this.foersteMoetenummer = plan.foersteMoetenummer;
        this.foersteSaksnummer = plan.foersteSaksnummer;
    }
}
